import type { DeepPartial } from '@apollo/client/utilities';
import { EmployeeLink } from '@/common/components/shared/link/EmployeeLink';
import { DateWithCount } from './DateWithCount';
import type { EmployeeAlertListItemReasonManager } from './types';

export const ManagerInformation = ({ manager }: { manager: DeepPartial<EmployeeAlertListItemReasonManager> }) => (
  <div>
    <div>
      <EmployeeLink className="font-medium" employeeId={manager?.id}>
        {manager?.generalInformation?.preferredFullName}
      </EmployeeLink>
      <span className="pl-1 text-2xs text-gray-7">#{manager?.id}</span>
    </div>
    <div>
      {manager?.offBoarding?.lastWorkingDate && (
        <div>
          Last working date:&nbsp;
          <DateWithCount date={manager.offBoarding.lastWorkingDate} />
        </div>
      )}
      {manager?.offBoarding?.employmentEndDate && (
        <div>
          Employment end date:&nbsp;
          <DateWithCount date={manager.offBoarding.employmentEndDate} />
        </div>
      )}
    </div>
  </div>
);
